import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categorias" className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            {t('categories_title')}
          </h2>
          <p className="text-foreground-500 text-sm mt-3">
            {t('categories_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-background-50 transition-all duration-300 flex flex-col cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} HoobuySpreadsheet`}
                  title={`${cat.name} - HoobuySpreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              <div className="p-5 md:p-6 flex flex-col items-center text-center gap-3">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {cat.name}
                </h3>

                <span
                  className={`inline-block font-label text-xs font-semibold px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    index === 0
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600'
                      : 'bg-background-100 text-foreground-700 border border-background-300 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500'
                  }`}
                >
                  {t('cta_explore')}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}